module.exports = __webpack_public_path__ + "img/start1.4d75d1a9.svg";